import { Deserializable } from './deserializable';
import { BaseModel } from './baseModel';
import { UserOwnerRel } from './userOwnerRel';
import { ControlUserInstallation } from './controlUserInstallation';

export class ActivationCode extends BaseModel implements Deserializable {

  id: number;

  userOwnerId: number;
  userOwner: UserOwnerRel;

  installationId: number;
  installation: ControlUserInstallation;

  code: string;
  description: string;

  activatedAt: Date;

  activationEmail: string;

  activationEmailSentDate: Date;

  deserialize(input: any) {
    super.deserialize(input);
    Object.assign(this, input);
    if (this.description == null) {
      this.description = "";
    }
    return this;
  }

}
